import { render, staticRenderFns } from "./SecondaryNavItem.vue?vue&type=template&id=21c3a1a6&scoped=true&"
import script from "./SecondaryNavItem.vue?vue&type=script&lang=js&"
export * from "./SecondaryNavItem.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryNavItem.vue?vue&type=style&index=0&id=21c3a1a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c3a1a6",
  null
  
)

export default component.exports